module.exports = __webpack_public_path__ + "static/media/todo-list.76caef93.png";